/* Enums */

export enum RedirectLogicalOperatorEnum {
    AND = 'and',
    OR = 'or',
  }
  
  export enum RedirectConditionOperatorEnum {
    IS = 'is',
    CONTAINS = 'contains',
  }
  
  export enum RedirectRuleStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
  }
  
  /* DTOs */
  
  export interface RedirectConditionDto {
    term: string;
    operator: RedirectConditionOperatorEnum;
  }
  
  export interface RedirectTriggerRulesDto {
    logicalOperator: RedirectLogicalOperatorEnum;
    conditions: RedirectConditionDto[];
  }
  
  export interface RedirectRuleDto {
    id: string;
    name: string;
    redirectUrl: string;
    triggerRules: RedirectTriggerRulesDto;
    status: RedirectRuleStatusEnum;
  }
  export interface CreateRedirectRuleResponse {
    id: string;
  }
  /* Paging */
  
  export interface PageDto {
    number: number;
    size: number;
    totalElements: number;
    totalPages: number;
    empty: boolean;
  }
  
  /* Response */
  
  export interface RedirectRuleListResponseDto {
    page: PageDto;
    items: RedirectRuleDto[];
  }
  export interface RedirectRuleListFilter {
    page?: number;
    size?: number;
    q?: string;
    active?: boolean;
  }
  export enum RedirectRuleErrorResponseEnum {
    DEFAULT = 'Ha ocurrido un error inesperado'
  }
  